// Tema visual do playbook Omnicore (Working Backwards).
// Os componentes de src/components/backwards/ têm como default os valores do
// playbook Nex2AI; este objeto concentra as substituições da Omnicore.
// IMPORTANTE: os valores são strings literais completas de classes Tailwind —
// o scanner do Tailwind v4 lê este arquivo ao gerar o output.css, então não
// montar classes dinamicamente fora daqui.
export const omnicoreTheme = {
  // Identidade
  logo: '../assets/backwards/omnicore-logo.svg',
  logoAlt: 'omnicore',
  heroBg: '../assets/backwards/omnicore-hero-bg.png',

  // Barras com a textura navy exportada do Figma (filtro exposure aplicado)
  topBar:
    "bg-[url('../assets/backwards/omnicore-bar-bg.png')] bg-cover bg-center",
  tableHead:
    "bg-[url('../assets/backwards/omnicore-bar-bg.png')] bg-cover bg-center",

  // Acentos
  accentBorder: 'border-[#2862B9]',
  accentIcon: 'text-[#2862B9]',

  // Abas
  tabActive: 'bg-[#264F8D] text-white font-titillium-web-semibold',
  productTabActive:
    'border-b border-[#2862B9] text-[#2862B9] font-inter-medium',

  // Cards de problema (bloco SOLUÇÃO azul)
  solutionBox: 'border-[#C1D5F3] bg-[#F3F8FF]',
  solutionLabel: 'text-[#2862B9]',

  // Chips e badges monoespaçados
  chip: 'rounded-[10px] border border-[#7984CC]/20 bg-[#F5F7FF] px-[11px] py-1 font-jetbrains-mono text-xs uppercase tracking-[0.05em] text-[#2862B9]',
  badge: 'border-[#2862B9]/20 bg-[#2862B9]/10 text-[#2862B9]',
  bullet: 'text-[#2862B9]',

  // FAQ de produto: perguntas sempre azuis (aberta e fechada) no Figma
  faqQuestion: 'text-[#2862B9]',
  faqOpen: 'text-[#2862B9]',
  faqIcon: 'text-[#2862B9]',
}
